import React from 'react';
import { List, Filter, Datagrid, ReferenceInput, SelectInput, EditButton, BooleanField, TextInput, TextField, NumberField } from 'react-admin';
import * as XLSX from "xlsx";

const ProductsTitle = () => {
    return <span>Listado de Productos</span>;
};

const ProductsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Buscar nombre" source="name" alwaysOn />
    <TextInput label="Código" source="code" alwaysOn />
    <ReferenceInput
      label="Categoría"
      source="categoryId"
      reference="categories"
      perPage={300}
      sort={{ field: "name", order: "ASC" }}
      filter={{}}
    >
      <SelectInput optionText="name" label="Categoría" />
    </ReferenceInput>
  </Filter>
);

// Función personalizada de exportación
const productsExporter = (data) => {
    const exportData = data.map(record => ({
        'ID': record.id,
        'Código': record.code,
        'Nombre': record.name,
        'Categoría': record.category?.name || '-',
        'Precio': record.price || 0,
        'Stock': record.stock || 0,
        'Habilitado': record.enabled ? 'Sí' : 'No'
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);

    const colWidths = Object.keys(exportData[0]).map(h => ({wch: Math.max(h.length, 15)}));
    ws['!cols'] = colWidths;

    XLSX.utils.book_append_sheet(wb, ws, "Productos");
    XLSX.writeFile(wb, `productos-${new Date().toISOString().split('T')[0]}.xlsx`);
};

export const ProductsList = (props) => (
  <List
    filters={<ProductsFilter />}
    title={<ProductsTitle />}
    {...props}
    sort={{ field: "id", order: "ASC" }}
    exporter={productsExporter}
  >
    <Datagrid rowClick="edit">
      <NumberField source="id" label="ID" />
      <TextField source="code" label="Código" />
      <BooleanField source="enabled" label="Habilitado" />
      <TextField source="name" label="Nombre" />
      <TextField source="category.name" label="Categoría" />
      <NumberField source="price" label="Precio" />
      <NumberField source="stock" label="Stock" />
      <EditButton />
    </Datagrid>
  </List>
);